var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-gray-100 py-6",
      staticStyle: { height: "calc(100vh - 70px)" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "bg-white overflow-hidden shadow rounded-lg max-w-xl mx-auto"
        },
        [
          _c(
            "div",
            {
              staticClass: "bg-white px-4 py-5 border-b border-gray-200 sm:px-6"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap"
                },
                [
                  _vm._m(0),
                  _c("div", { staticClass: "ml-4 mt-2 flex-shrink-0" }, [
                    _c(
                      "span",
                      { staticClass: "inline-flex rounded-md shadow-sm" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.createNew("Abandoned")
                              }
                            }
                          },
                          [_vm._v(" Create new ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          ),
          _c("div", [
            _c(
              "ul",
              _vm._l(_vm.templates, function(template) {
                return _c("TemplateItem", {
                  key: template.id,
                  attrs: { template: template },
                  on: {
                    edit: function($event) {
                      return _vm.onEdit($event, "Abandoned")
                    },
                    delete: function($event) {
                      return _vm.onDelete($event, "Abandoned")
                    }
                  }
                })
              }),
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "bg-white overflow-hidden shadow rounded-lg max-w-xl mx-auto mt-5"
        },
        [
          _c(
            "div",
            {
              staticClass: "bg-white px-4 py-5 border-b border-gray-200 sm:px-6"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap"
                },
                [
                  _vm._m(1),
                  _c("div", { staticClass: "ml-4 mt-2 flex-shrink-0" }, [
                    _c(
                      "span",
                      { staticClass: "inline-flex rounded-md shadow-sm" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.createNew("Order")
                              }
                            }
                          },
                          [_vm._v(" Create new ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          ),
          _c("div", [
            _c(
              "ul",
              _vm._l(_vm.orderTemplates, function(template) {
                return _c("TemplateItem", {
                  key: template.id,
                  attrs: { template: template },
                  on: {
                    edit: function($event) {
                      return _vm.onEdit($event, "Order")
                    },
                    delete: function($event) {
                      return _vm.onDelete($event, "Order")
                    }
                  }
                })
              }),
              1
            )
          ])
        ]
      ),
      _vm.showModal
        ? _c("TemplateModal", {
            attrs: {
              template: _vm.currentTemplate,
              templateType: _vm.templateType
            },
            on: {
              edit: _vm.onUpdate,
              close: _vm.closeModal,
              create: _vm.onCreate
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-4 mt-2" }, [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Abandoned Carts Templates ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-4 mt-2" }, [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Order Templates ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }